import { Datagrid, TextField, List, TextInput, Edit, SimpleForm, Create, Button, FilterButton } from 'react-admin';
import { SaveButton, Toolbar, useNotify, useRedirect, DeleteButton } from 'react-admin';
import { SearchInput, EditButton, ReferenceField, SelectInput, ReferenceInput } from 'react-admin';

import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices } from 'react-admin';
import { CreateButton, ExportButton, TopToolbar } from 'react-admin';
import { getAuthData, url_download_template } from '../constant/constant';
import { Link } from 'react-router-dom';
import Alert from '@mui/material/Alert';

const validateName = [required(), minLength(3), maxLength(30)];
const validateAddress = [required(), minLength(3)];
const validatePhone = [required(), number(), minLength(9), maxLength(14)];
const validateRek = [required(), number(), minLength(9)];



const mitraFilters = [
    <SearchInput source="nama" alwaysOn />,
    <ReferenceInput source="id_wilayah" label="Wilayah" reference="master_kab">
        <SelectInput optionText="nama_kab" />
    </ReferenceInput>
];

const MitraSaveButton = props => {
    const notify = useNotify();
    const redirect = useRedirect();
    return <SaveButton {...props} type="button" 
        mutationOptions={{
            onSuccess: (response) => {
                notify(`User "${response.nama}" created!`);
                redirect('/mitra');
        }}
    } 
    />;
};

const MitraCreateToolbar = () => (
    <Toolbar>
        <MitraSaveButton />
        <DeleteButton />
    </Toolbar>
);

const MitraListActions = () => (
    <TopToolbar>
        <Link to="/mitra/import" style={{textDecoration: "none", display: getAuthData()["role"]=="2"?"none":"inline-flex"}}><Button variant="outlined" label='Import Template'/></Link>
        <a style={{textDecoration: "none", display: getAuthData()["role"]=="2"?"none":"inline-flex"}} href={url_download_template} download><Button variant="contained" label='Download Template'/></a>
        <FilterButton />
        <CreateButton style={{display: getAuthData()["role"]=="2"?"none":"inline-flex"}} />
        <ExportButton />
    </TopToolbar>
);

export const MitraList = () => (
    <List filters={mitraFilters} actions={<MitraListActions/>}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="nama" />
            <TextField source="no_hp" />
            <TextField source="alamat" />
            {/* <TextField source="pendidikan" /> */}
            <ReferenceField source="pendidikan" reference="pendidikan" link={false} >
                <TextField source="nama" />
            </ReferenceField>
            {/* <TextField source="jenis_bank" /> */}
            <ReferenceField source="jenis_bank" reference="bank" link={false} >
                <TextField source="nama" />
            </ReferenceField>
            
            <TextField source="no_rekening" />
            <ReferenceField source="id_wilayah" label="Wilayah" reference="master_kab" link={false} >
                <TextField source="nama_kab" />
            </ReferenceField>
            <EditButton style={{display: getAuthData()["role"]=="2"?"none":"inline-flex"}} />
        </Datagrid>
    </List>
);

export const MitraEdit = () => (
    <div>
        <Alert style={{marginTop: "20px"}} severity="warning">Pastikan No HP, Jenis Bank dan Rekening Unik!</Alert>
        <Edit>
            <SimpleForm>
                {/* <TextInput source="id" /> */}
                <TextInput source="nama" validate={validateName} />
                <TextInput source="no_hp" validate={validatePhone} />
                <TextInput source="alamat" validate={validateAddress}/>
                {/* <TextInput source="pendidikan" /> */}
                <ReferenceInput source="pendidikan" reference="pendidikan">
                    <SelectInput optionText="nama" validate={[required()]} />
                </ReferenceInput>
                {/* <TextInput source="jenis_bank" /> */}
                <ReferenceInput source="jenis_bank" reference="bank">
                    <SelectInput optionText="nama" validate={[required()]} />
                </ReferenceInput>
                <TextInput source="no_rekening" validate={validateRek} />
                <ReferenceInput source="id_wilayah" reference="master_kab">
                    <SelectInput optionText="nama_kab" validate={[required()]}/>
                </ReferenceInput>
            </SimpleForm>
        </Edit>
    </div>
    
);

export const MitraCreate = (props) => (
    <div>
        <Alert style={{marginTop: "20px"}} severity="warning">Pastikan No HP, Jenis Bank dan Rekening Unik!</Alert>
        <Create {...props}>
            <SimpleForm toolbar={<MitraCreateToolbar/>}>
                <TextInput source="nama" validate={validateName}/>
                <TextInput source="no_hp" validate={validatePhone} />
                <TextInput source="alamat" validate={validateAddress} />
                {/* <TextInput source="pendidikan" /> */}
                <ReferenceInput source="pendidikan" reference="pendidikan">
                    <SelectInput optionText="nama" validate={[required()]} />
                </ReferenceInput>
                {/* <TextInput source="jenis_bank" /> */}
                <ReferenceInput source="jenis_bank" reference="bank">
                    <SelectInput optionText="nama" validate={[required()]} />
                </ReferenceInput>
                <TextInput source="no_rekening" validate={validateRek} />
                <ReferenceInput source="id_wilayah" reference="master_kab">
                    <SelectInput optionText="nama_kab" validate={[required()]}/>
                </ReferenceInput>
            </SimpleForm>
        </Create>
    </div>
    
);